import React, { Component } from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Home from './Home';
import News from './News';
import About from './About';
import Authnicate from './Authnicate'; 
import Happenings from './Happenings'; 
import Awards from './Awards'; 
import Chairmanmsg from './Chairmanmsg'; 
import Directormsg from './Directormsg';
import Assets from './assets';
import AssetsDownload from './assetsDownload';
import ChairmanMessage from './chairmanMessage';
import Privacy from './Privacy';
import Promotion from './promotion';
import Covid from './Covid';
import Bulletin from './bulletin';
import SpecialBulletins from './specialBulletin';
import Dummy from './dummy';


class App extends Component {

  constructor(props){
    super(props);
    this.state = {
        empcode: "",
        access_token: "",
        isLoading: false,
        authData:[],
    } 
  }

  render() {
    return (
      <Router>
      	<Switch>
	        <Route exact path="/" component={Authnicate}/>
          <Route exact path="/" component={Home}/>
          <Route exact path="/news" component={News}/>
          <Route exact path="/happenings" component={Happenings}/>
          <Route exact path="/aboutus" component={About}/>
          <Route exact path="/awardsrecognition" component={Awards}/>
          <Route exact path="/chairmanMessage" component={Chairmanmsg}/>
          <Route exact path="/directormessage" component={Directormsg}/>
          <Route exact path="/assets" component={Assets}/>
          <Route exact path="/assetsDownload" component={AssetsDownload}/>
          <Route exact path="/messageChairman" component={ChairmanMessage}/>
          <Route exact path="/privacy" component={Privacy}/>
          <Route exact path="/covid" component={Covid}/>
          <Route exact path="/promotion" component={Promotion}/>
          <Route exact path="/bulletin" component={Bulletin}/>
          <Route exact path="/specialBulletin" component={SpecialBulletins}/>
          <Route exact path="/dummy" component = {Dummy}/>
        </Switch>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js